import React from 'react';
import { useServiceDate } from '../../../../hooks/useServiceDate';
import { useLanguage } from '../../../../locale/useLanguage';
import { Order } from '../../../../models';

import './OrderHeader.css';

type OrderHeaderProps = {
  order: Order;
};

export const OrderHeader: React.FC<OrderHeaderProps> = ({ order }) => {
  const [t] = useLanguage();

  const serviceDate = useServiceDate(order);

  return (
    <div>
      <p className="order-header--shipping">
        {t('chooseTransaction.shipping')}
      </p>
      <h2 className="order-header--shipper">
        {order.shipper.alias || order.shipper.name}
      </h2>
      <p className="paragraph">{order.shipperOrderCode}</p>
      <p className="paragraph">{serviceDate?.format('DD MMMM YYYY')}</p>
    </div>
  );
};
